import React from 'react';
import PostPaymentContractProductsList from './PostPaymentContractProductsList';
import UpfrontContractProductsList from './UpfrontContractProductsList';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import DowngradeContractFormService from '../services/DowngradeContractFormService';

class DowngradeContractProductsListContainer extends React.Component {
  render() {
    const contractType = toJS(DowngradeContractFormService.contract.type);
    const currencyType =
      !DowngradeContractFormService.form.getValue('country') ||
      BRAZIL.includes(DowngradeContractFormService.form.getValue('country'))
        ? 'real'
        : 'dollar';

    if (contractType === 'UPFRONT') {
      return (
        <UpfrontContractProductsList
          disabled={DowngradeContractFormService.fetch.fetching || DowngradeContractFormService.submit.fetching}
          onDelete={DowngradeContractFormService.productsService.handleDelete}
          onEdit={DowngradeContractFormService.productsService.handleEdit}
          data={toJS(DowngradeContractFormService.productsService.contractProducts)}
          loading={DowngradeContractFormService.fetch.fetching}
          submitting={DowngradeContractFormService.submit.fetching}
          currencyType={currencyType}
          onToggleProduct={DowngradeContractFormService.productsService.handleToggleProduct}
        />
      );
    }

    return (
      <PostPaymentContractProductsList
        disabled={DowngradeContractFormService.fetch.fetching || DowngradeContractFormService.submit.fetching}
        onDelete={DowngradeContractFormService.productsService.handleDelete}
        onEdit={DowngradeContractFormService.productsService.handleEdit}
        data={toJS(DowngradeContractFormService.productsService.contractProducts)}
        loading={DowngradeContractFormService.fetch.fetching}
        submitting={DowngradeContractFormService.submit.fetching}
        currencyType={currencyType}
      />
    );
  }
}

export default observer(DowngradeContractProductsListContainer);
